import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/hooks/useAuth';
import { useEffect } from 'react';
import useCurrentUserDetailsLazy from '../adapters/hooks/useCurrentUserDetails';

const RequireAuth = () => {
  const location = useLocation();
  const { execute: getCurrentUser } = useCurrentUserDetailsLazy();
  const {
    loggedInUser,
    setLoggedInUser,
    setCurrentHospitalId,
    setIsMultipleHospitals,
  } = useAuth();

  useEffect(() => {
    const getUser = async () => {
      try {
        const user = await getCurrentUser();
        setLoggedInUser(user);
        if (user.hospitals.length > 0) {
          setIsMultipleHospitals(user.hospitals.length > 1);
          setCurrentHospitalId(user.hospitals[0]);
        }
      } catch (e) {
        setLoggedInUser(null);
      }
    };

    if (loggedInUser === undefined) {
      getUser();
    }
  }, [loggedInUser, getCurrentUser, setLoggedInUser, setCurrentHospitalId]);

  //   const isAllowed = loggedInUser && (!roles || hasAnyRole(roles));
  const isAllowed = loggedInUser;

  if (!isAllowed) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return <Outlet />;
};

export default RequireAuth;
